import { Icon } from '@cxc/react-fds-components'
import './ErrorBanner.css'
import { useEffect, useRef } from 'react'

const ErrorBanner = ({ message = '' }: { message?: string }) => {
  const bannerRef = useRef<HTMLParagraphElement>(null)

  useEffect(() => {
    if (message && message !== '') {
      bannerRef.current?.focus()
    }
  }, [message])

  return (
    <div
      className={`fds-layout-grid__cell--span-12 z-index-0 ${
        message && message !== '' ? '' : 'hide-error-banner'
      }`}
    >
      <p
        id={'error-banner'}
        data-testid={'error-banner'}
        className={'fds-color__text--white'}
        role={'alert'}
        ref={bannerRef}
        tabIndex={-1}
      >
        <Icon
          name="error"
          size={16}
          style={{
            verticalAlign: 'baseline',
            paddingRight: '5px',
            color: 'white',
          }}
          aria-hidden={true}
        />
        {message}
      </p>
    </div>
  )
}

export default ErrorBanner
